/**
 * atomberg-login-return-to.js
 *
 * Fixes a landing-page bug in the native customer-accounts login link
 * (`routes.storefront_login_url`, rendered in header-actions.liquid and
 * cart-products.liquid): Shopify bakes a `return_to` param into that URL
 * reflecting whatever URL the *enclosing Liquid render* happened to be
 * serving. Horizon refreshes the cart drawer via a background
 * `?section_id=...` fetch (see assets/section-renderer.js,
 * assets/component-cart-items.js) whenever the cart changes — and since the
 * cart drawer lives inside the header section, that fetch re-renders the
 * whole header, login link included. Shopify renders that fetch's own URL as
 * the "current page", so the freshly morphed login link's return_to points
 * at `/?section_id=...__header_section` instead of the page the customer is
 * actually on. Logging in from that morphed link lands the customer on
 * Shopify's raw section-rendering output after the OIDC round trip.
 *
 * Fix: never trust the link's baked-in return_to. Intercept the click
 * (document-level, capture phase — the anchor is replaced wholesale whenever
 * Horizon morphs its section, so a listener bound to the element itself
 * would be lost, and capture phase runs before any dropdown/menu handler on
 * the way up could stop propagation first) and overwrite return_to with the
 * true top-level page URL, read fresh at click time — which is unaffected by
 * any background section_id fetch, since those never touch the address bar.
 */
(function () {
  'use strict';

  var w = /** @type {any} */ (window);
  if (w._atombergLoginReturnToInit) return;
  w._atombergLoginReturnToInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var target = /** @type {Element} */ (event.target);
      var trigger = target.closest('a[href*="/customer_authentication/login"]');
      if (!trigger) return;

      // The RazorpayId popup (atomberg-razorpay-id.js) owns this same anchor
      // once its SDK is ready — it opens an in-page popup instead of
      // navigating. Our window.location.href below is a programmatic
      // navigation that preventDefault() can't cancel, so we must yield
      // explicitly rather than rely on listener order. When the popup isn't
      // ready, the normal login link (with the fixed return_to) still applies.
      if (trigger.hasAttribute('data-atomberg-razorpay-id-trigger') && w._atombergRazorpayIdReady)
        return;

      var anchor = /** @type {HTMLAnchorElement} */ (trigger);
      var fixedUrl;
      try {
        var url = new URL(anchor.href, window.location.origin);
        url.searchParams.set('return_to', window.location.pathname + window.location.search);
        fixedUrl = url.toString();
      } catch (e) {
        return; // Malformed href — leave the click alone rather than risk a worse redirect.
      }

      event.preventDefault();
      window.location.href = fixedUrl;
    },
    true
  );
})();
